import { observer } from "mobx-react-lite";

import { Group } from "@/components/expression/utils/groups/Group";
import * as Node from "@/components/expression/utils/layout";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { useNodeHover } from "@/components/expression/utils/useNodeHover";
import { twMerge } from "@/utils/twMerge";

import type { ExpressionComponent } from "./types";

export const PostfixOperatorNode: ExpressionComponent<"operator"> = observer(function FunctionNode({
  node,
  className,
}) {
  const { doc, parameters } = node;

  const { view } = useNodeStyle();
  const { isHovered } = useNodeHover(node);

  const isFocused = doc.cursor.isOnNode(node);
  const parametersAreFocused = doc.cursor.nodesAreFocused(node.parameters);
  const isHighlighted = parametersAreFocused || isHovered;
  const isExpanded = parameters[0]?.nodes.length > 1;
  const hideParentheses = !isExpanded && !isFocused;
  const isTextView = view === "text";

  return (
    <div className={className}>
      <Node.Container
        node={node}
        className={twMerge("inline-flex items-baseline pr-0", hideParentheses && "px-0")}
      >
        <Group
          node={node}
          parameters={parameters}
          openingSymbol="("
          closingSymbol=")"
          compensateBracketWidthRight={1}
          compensateBracketWidthLeft={0}
          hideParentheses={hideParentheses}
          disabled={!isExpanded}
          className="z-10"
        />
        <Node.Value
          className={twMerge(
            "min-w-3 pr-0.1 text-center",
            !hideParentheses && "pl-1.5",
            isHighlighted && !isTextView && "text-node-active",
            isTextView && "min-w-0 p-0",
          )}
        >
          {node.operatorSymbol}
        </Node.Value>
      </Node.Container>
    </div>
  );
});
